export default __webpack_public_path__ + "static/media/aqua7.3798ffcf.png";